/*
export function someMutation (state) {
}
*/
import _ from 'lodash'
import { Notify } from 'quasar'
import { nestedVueSet } from 'src/services/utils'

export function clearAll (state) {
  state.feApps = []
  clearSelectedFeApp(state)
}

export function clearSelectedFeApp (state) {
  state.selectedFeAppId = null
  state.entities = { list: [], byId: {}, byType: {} }
  state.devices = { list: [], byId: {} }
  state.links = []
  state.networkAssets = []

  state.selectedModule = null
  state.selectedEntity = null
}

export function setFeApps (state, apps) {
  console.log('app:commit:setFeApps')
  state.feApps = apps // all apps for a user
}

export function replaceBeApp (state, beApp) {
  const existingIdx = _.findIndex(state.feApps, fEapp => fEapp.app.id === beApp.id)
  if (existingIdx === -1) {
    console.warn('app:commit:replaceBeApp', 'App not found to replace: ' + beApp.id)
  } else {
    state.feApps[existingIdx].app = beApp
  }
}

export function setEntities (state, e) {
  console.log('app:commit:setEntities', e.list.length)
  state.entities = e
}

export function setNetworkAssets (state, nwas) {
  console.log('app:commit:setNetworkAssets', nwas.length)
  state.networkAssets = nwas
}

export function addEntity (state, e) {
  console.log('app:commit:addEntity', e.entity.id)

  state.entities.list.push(e)
  state.entities.byId[e.entity.id] = e

  if (!state.entities.byType[e.entity.type]) {
    state.entities.byType[e.entity.type] = []
  }
  state.entities.byType[e.entity.type].push(e)
}

export function addNetworkAsset (state, nwa) {
  console.log('app:commit:addNetworkAsset', nwa.id)
  state.networkAssets.push(nwa)
}

/**
 * Inserts or updates link into:
 * 1. state.links
 * 2. an entity's feEntity.links array
 * 3. a device's feDevice.links array
 *
 * TODO replace entity and device lists with globally computed alternative
 * @param {*} state
 * @param {*} link
 */
export function addLink (state, link) {
  // link could be new or existing
  var lindex = _.findIndex(state.links, l => l.id === link.id)
  if (lindex === -1) {
    state.links.push(link)
  } else {
    state.links.splice(lindex, 1, link)
  }

  var feEnt = state.entities.byId[link.entityId]
  if (feEnt) {
    var eindex = _.findIndex(feEnt.links || [], l => l.id === link.id)
    if (eindex === -1) {
      if (!feEnt.links) { feEnt.links = [] }
      feEnt.links.push(link)
    } else {
      feEnt.links.splice(eindex, 1, link)
    }
  }

  var feDev = state.devices.byId[link.deviceId]
  if (feDev) {
    var dindex = _.findIndex(feDev.links || [], l => l.id === link.id)
    if (dindex === -1) {
      if (!feDev.links) { feDev.links = [] }
      feDev.links.push(link)
    } else {
      feDev.links.splice(dindex, 1, link)
    }
  }
}

export function updateEntity (state, e) {
  console.log('app:commit:updateEntity', e.entity.id)

  // first swap-out the existing one in the main list
  var index = _.findIndex(state.entities.list, fe => fe.entity.id === e.entity.id)
  if (index === -1) {
    state.entities.list.push(e)
  } else {
    var existing = state.entities.list[index]
    _(e).toPairs().forEach(pair => { // overwrite all properties
      _.set(existing, pair[0], pair[1])
    })
  }

  // next swap the byId indexed one
  state.entities.byId[e.entity.id] = e

  // next swap-out the existing one in the group-by-type list
  var type = e.entity.type
  var tindex = _.findIndex(state.entities.byType[type], fe => { return fe.entity.id === e.entity.id })
  if (tindex === -1) {
    state.entities.byType[type].push(e)
  } else {
    state.entities.byType[type].splice(tindex, 1, e)
  }
}

export function updateDevice (state, d) {
  console.log('app:commit:updateDevice', d.device.id)

  // first swap-out the existing one in the main list
  var index = _.findIndex(state.devices.list, fe => fe.device.id === d.device.id)
  if (index === -1) {
    state.devices.list.push(d)
  } else {
    var existing = state.devices.list[index]
    _(d).toPairs().forEach(pair => { // overwrite all properties
      _.set(existing, pair[0], pair[1])
    })
  }

  // next swap the byId indexed one
  state.devices.byId[d.device.id] = d
}

export function addDevice (state, d) {
  console.log('app:commit:addDevice', d.device.id)

  state.devices.list.push(d)
  state.devices.byId[d.device.id] = d
}

export function setLinks (state, e) {
  console.log('app:commit:setLinks', e.length)
  state.links = e
}

export function setDevices (state, e) {
  console.log('app:commit:setDevices', e.list.length)
  state.devices = e
}

export function setSelectedFeAppId (state, appId) {
  state.selectedFeAppId = appId
  console.log('app:commit:setSelectedFeAppId', state.selectedFeAppId)
}

export function setSelectedModule (state, module) {
  console.log('app:commit:setSelectedModule:' + (module == null ? 'null' : module.id))
  state.selectedModule = module
}

export function selectModule (state, modId) {
  console.log('looking for module: ' + modId)
  for (var i = 0; i < state.app.modules.length; i++) {
    var mod = state.app.modules[i]
    if (mod.id === modId) {
      console.log('Found module: ' + modId)
      state.module = mod
      break
    }
  }
}

export function selectEntity (state, entityId) {
  if (entityId == null) {
    state.entity = false
  }

  console.log('looking for entity: ' + entityId)
  for (var i = 0; i < state.entities.length; i++) {
    var ent = state.app.entities[i]
    if (ent.id === entityId) {
      console.log('Found entity: ' + entityId)
      state.entity = ent
      return
    }
  }

  state.entity = null
}

export function setEntityProperty (state, payload) {
  var entityId = payload.entityId
  var property = payload.propertyPath
  var value = payload.value

  var entity = state.entities.byId[entityId]
  if (!entity) {
    Notify.error('Could not find entity: ' + entityId)
    return
  }

  nestedVueSet(entity.entity, property, value)
}

export function updateSelectedModulePageCfg (state, payload) {
  var pageKey = payload.pageKey
  var pageCfg = payload.pageCfg
  console.log(pageKey, pageCfg, state.selectedModule)
  _.set(state.selectedModule.uiPages, pageKey, pageCfg)
}

export function replaceSelectedAppLocations (state, locations) {
  replaceSelectedAppPathProperty(state, 'locations', locations)
}

export function replaceSelectedAppPathProperty (state, path, property) {
  if (!state.selectedFeAppId) { return }
  if (!path) { return }

  const feApp = _.find(state.feApps, (feApp) => feApp.app.id === state.selectedFeAppId)
  if (!feApp) { return }
  _.set(feApp, 'app.' + path, property)
}
